"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var jsx_runtime_1 = require("react/jsx-runtime");
var compat_1 = require("preact/compat");
var styles_scss_1 = __importDefault(require("./styles.scss"));
var ApplicationIframe = function (_a) {
    var src = _a.src, show = _a.show, onClose = _a.onClose, onGtag = _a.onGtag;
    var iframe = (0, compat_1.createRef)();
    var onRedirect = function (event) {
        onClose();
        if (event.data.url) {
            window.location.href = event.data.url;
        }
    };
    var onMessage = function (event) {
        var type = event.data.type;
        switch (type) {
            case "redirect":
                onRedirect(event);
                break;
            case "closeIframe":
                onClose();
                break;
            case "analytics":
                onGtag(event.data);
                break;
            default:
                break;
        }
    };
    (0, compat_1.useEffect)(function () {
        // listen to iframe events
        window.addEventListener("message", onMessage);
        // remove listener on unmount
        return function () { return window.removeEventListener("message", onMessage); };
    }, []);
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: show &&
            (0, jsx_runtime_1.jsx)("div", __assign({ className: styles_scss_1["default"].applicationIframe }, { children: (0, jsx_runtime_1.jsx)("iframe", { ref: iframe, title: "application", src: src }) })) }));
};
exports["default"] = ApplicationIframe;
